<template>
    <section :class="['box-typical', 'page-builder', show || 'hide']">
        <div class="tab-content" style="overflow: visible; height: auto;">
            <div role="tabpanel" class="clearfix tab-pane active" id="tab-contact-1">
                <div class="row">
                    <div class="col-md-4 multi-select">
                        <h4 class="mt-0">Panels</h4>
                        <draggable
                            v-if="initialized"
                            v-model="items"
                            v-on:end="changePriority"
                            class="list-group overflow-y-hidden">
                            <a  v-for="item in items"
                                v-on:click="changePanel(item.id)"
                                :key="item.id"
                                :class="['list-group-item', 'list-group-item-action', (item.id == currentPanelId) ? 'selected' : '']">
                                <i class="material-icons drag-icon">view_headline</i>
                                <span class="list-group-item-label">
                                    {{ item.name }}<br/><small>{{ item.description }}</small>
                                </span>

                                <button type="button"
                                    v-if="item.id != 0"
                                    v-on:click="deletePanel(item)"
                                    class="btn btn-white btn-rounded btn-sm mt-1_">
                                    <i class="material-icons">delete_outline</i></button>
                            </a>
                            <div class="text-center mt-2">
                                <button type="button"
                                        v-on:click="openCreateModal"
                                        class="btn btn-rounded btn-icon btn-sm btn-success">
                                    <i class="material-icons">add</i>Create New Panel</button>
                            </div>
                        </draggable>
                        <div v-else style="padding: 8rem;">
                            <vue-spinner></vue-spinner>
                        </div>
                    </div><!--.page-col-left-->
                    <div class="col-md-8">

                        <div class="page-col-right-in">
                            <h4 class="mt-0">
                                Content
                                <div class="btn-group btn-group-toggle float-right border">
                                    <button v-on:click="() => previewMode = null"
                                        :class="['btn', 'btn-trans', 'px-2', !previewMode ? 'active' : '']"
                                        ><i class="material-icons">edit</i></button>
                                    <button v-on:click="() => previewMode = 'desktop'"
                                        :class="['btn', 'btn-trans', 'px-2', previewMode == 'desktop' ? 'active' : '']"
                                        ><i class="material-icons">computer</i></button>
                                    <button v-on:click="() => previewMode = 'mobile'"
                                        :class="['btn', 'btn-trans', 'px-2', previewMode == 'mobile' ? 'active' : '']"
                                        ><i class="material-icons">smartphone</i></button>
                                </div>
                            </h4>
                            <div v-if="previewMode" class="tab-content">
                                <iframe id="previewIframe" scrolling="no"
                                    :class="['layout-preview', 'mt-3', 'layout-preview-' + previewMode]"
                                    :src="getPanelPreviewLink()"></iframe>
                            </div>
                            <template v-else>
                                <template v-if="currentPanelId == 0">
                                    <slot name="name" />
                                    <slot name="intro" />
                                    <slot name="heading" />
                                    <slot name="subheading" />
                                    <slot name="content" />
                                </template>
                                <form-component v-else
                                    :timestamp="timestamp"
                                    :type="_.get(currentPanel, 'type')"

                                    :id="_.get(currentPanel, 'id')"
                                    :key="_.get(currentPanel, 'id')"
                                    :parent="parent"
                                    :attributes="_.get(currentPanel, 'attributes')"
                                    :meta="_.get(currentPanel, 'meta')"
                                    :schema="_.get(currentPanel, 'schema.attributes')"
                                    :config="formConfig"
                                    :resourceParams="resourceParams"

                                    :changeUrl="changeUrl"
                                    :changeSection="changeSection"
                                    :changeQuery="changeQuery"

                                    :addNotification="addNotification"

                                    :createData="doNothing"
                                    :updateData="doNothing"
                                    :deleteData="doNothing"

                                    :onInitialized="doNothing"
                                    :onCreated="doNothing"
                                    :onChanged="editPanel"
                                    :onUpdated="doNothing"
                                    :onDeleted="doNothing"
                                    ></form-component>
                            </template>
                        </div><!--.page-col-right-in-->
                    </div><!--.page-col-right-->
                </div>
            </div><!--.tab-pane-->
            <!--.tab-pane-->
        </div><!--.tab-content-->
        <b-modal
            v-on:ok="addPanel"
            v-on:cancel="closeCreateModal"
            v-on:hide="() => showCreateModal = false"
            :visible="showCreateModal"
            header-class="border-0"
            body-class="p-0"
            size="lg"
            title="">
            <div class="page-builder-modal">
                <b-card no-body>
                    <b-tabs card nav-wrapper-class="nav-tabs-two">
                        <b-tab title="Choose from panel library" active>
                            <div class="page-builder-modal-header">
                                <label class=""><b>{{ initialized ? 'Select panel:' : 'Loading...' }}</b></label>
                            </div>
                            <div class="page-builder-modal-in">
                                <radio-list-component
                                    v-if="initialized"
                                    v-on:input="selectPanel"
                                    :value="_.get(panelOption, 'id')"
                                    :options="panelOptions"
                                    :config="globalPanelConfig"
                                    ></radio-list-component>
                            </div>
                        </b-tab>
                        <b-tab title="Create new panel">
                            <div class="page-builder-modal-header">
                                <label class=""><b>{{ initialized ? 'Select panel type:' : 'Loading...' }}</b></label>
                            </div>
                            <div class="page-builder-modal-in">
                                <radio-list-component
                                    v-if="initialized"
                                    v-on:input="selectPanelType"
                                    :options="panelTypes"
                                    :config="localPanelConfig"
                                    ></radio-list-component>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </b-modal>
    </section><!--.box-typical-->
</template>
<script>
import _ from 'lodash';
import Vuex from 'vuex';
import Draggable from 'vuedraggable';
import FormComponent from '../FormComponent';
import CustomSelectComponent from './CustomSelectComponent';
import RadioListComponent from '../form-elements/RadioListComponent';

import MoonLoader from 'vue-spinner/src/MoonLoader.vue';

export default {
    data() {
        return {
            previewMode: null,
            currentPanelId: 0,
            showCreateModal: false,
            items: [{
                id: 0,
                name: 'Main Content',
                description: 'Page Content'
            }],
            panelOption: null,
            initialized: false,
            panelConfig: {

            },
            localActive: true,
        }
    },

    props: ['section', 'showOnSection', 'name'],

    components: {
        Draggable,
        FormComponent,
        CustomSelectComponent,
        RadioListComponent,
        VueSpinner: MoonLoader,
    },

    mounted() {
        if (this.page.id) {
            const link = `/api/${this.page.type}/${this.page.id}`;

            this.getInitialData(link)
                .then(() => this.initialized = true);
        } else {
            this.initialized = true;
        }

        window.addEventListener('message', (e) => {
            if (e.data.type == 'layout') {
                const iframe = document.getElementById('previewIframe');
                iframe.setAttribute('height', e.data.payload.height);
            }
        });
    },

    watch: {
        timestamp() {
            const beforeMainItems = _.chain(this.content.data)
                .filter(panel => panel.attributes.section == 'before')
                .map((panel) => {
                    const type = _.get(panel, 'type', '').split('.').pop();

                    return {
                        id: panel.id,
                        name: panel.attributes.name,
                        position: panel.attributes.position,
                        dirty: false,
                        ...panel,
                        description: this.getPanelLabel(type),
                    }
                })
                .sortBy(['position'])
                .concat([{ id: 0, name: 'Main Content', description: 'Page Content' }])
                .value();

            const afterMainItems = _.chain(this.content.data)
                .filter(panel => panel.attributes.section != 'before')
                .map((panel) => {
                    const type = _.get(panel, 'type', '').split('.').pop();

                    return {
                        id: panel.id,
                        name: panel.attributes.name,
                        position: panel.attributes.position,
                        dirty: false,
                        ...panel,
                        description: this.getPanelLabel(type),
                    }
                })
                .sortBy(['position'])
                .value();

            this.items = _.concat(beforeMainItems, afterMainItems);
        }
    },

    computed: {
        ...Vuex.mapGetters({
            page: 'content',
        }, { root: true }),

        ...Vuex.mapGetters('panels', {
            content: 'content',
            parent: 'parent',
            timestamp: 'timestamp',
            resourceParams: 'resourceParams',

            localPanels: 'localPanels',
            globalPanels: 'globalPanels',
        }),

        show() {
            return (this.showOnSection == this.section);
        },

        currentPanel() {
            const panel = this.items.find(item => item.id == this.currentPanelId);
            return panel;
        },

        panelOptions() {
            const attachedIds = _.map(this.content.data, (panel) => panel.id);
            return _.chain(this.globalPanels)
                .concat(this.localPanels)
                .uniqBy('id')
                .filter(item => attachedIds.indexOf(item.id) < 0)
                .map(item => ({
                    id: item.id,
                    ...item.attributes,
                })).value();
        },

        panelTypes() {
            return _.get(this.content, 'schema.attributes.type.values', [])
                .filter(value => _.get(value, 'config.local'))
        },

        globalPanelConfig() {
            return {
                values: this.panelOptions
                    .map(option => {
                        return {
                            ...option,
                            image: this.getPanelImage(option.type),
                            description: option.description || this.getPanelDescription(option.type),
                        }
                    })
            }
        },

        localPanelConfig() {
            return {
                values: this.panelTypes
                    .map(option => {

                        return {
                            ...option,
                            name: this.getPanelLabel(option.id),
                            image: this.getPanelImage(option.id),
                            description: option.description || this.getPanelDescription(option.id),
                        }
                    })
            }
        },

        formConfig() {
            const type = _.get(this.currentPanel, 'type');
            return this.config(['form', type]);
        },
    },

    methods: {
        ...Vuex.mapActions({
            addNotification: 'addNotification',
            pushQueue: 'pushQueue',
        }, { root: true }),

        ...Vuex.mapActions('panels', [
            'getInitialData',
            'createData',
            'updateBatch',

            'changeUrl',
            'changeQuery',
            'changeSection',
            'changePath',
            'setContent',
        ]),

        doNothing() {

        },

        // Implement delayed batch update here which will push update to a queue
        // and execute it when main content is saved
        updateBatchDelayed(payload) {
            this.pushQueue({ 'panels/updateBatch': payload });
        },

        selectPanel(id) {
            this.panelOption = this.panelOptions.find(option => option.id == id);
        },

        selectPanelType(value) {
            const type = value;

            this.panelOption = {
                type,
                id: null,
                name: `New ${type}`,
            }
        },

        changePanel(id) {
            this.currentPanelId = id;
        },

        openCreateModal() {
            this.showCreateModal = true;
        },

        closeCreateModal() {
            this.showCreateModal = false;
        },

        editPanel(content) {
            const item = this.items.find(p => p.id == this.currentPanelId);

            if (item.id == 0) {
                return;
            }

            item.attributes = { ...item.attributes, ...content.data }

            const notEditableFields = [
                'position', 'section', 'content_id',
            ];
            this.updateBatchDelayed({
                data: [{
                    id: item.id,
                    $update_origin: _.pickBy(item.attributes, (value, key) => {
                        return !_.includes(notEditableFields, key);
                    })
                }],
            });
            this.$emit('input');
        },

        addPanel() {
            if (!this.panelOption) {
                return;
            }

            if (this.panelOption.id) {
                this.updateBatch({
                    data: [{ id: this.panelOption.id, $attach: true }],
                }).then(() => this.currentPanelId = this.panelOption.id)
            } else {
                this.createData({
                    data: { ...this.panelOption, content_id: _.get(this.page, 'attributes.content_id') },
                    options: {
                        setNotification: true,
                        addToCollection: true,
                    }
                }).then((res) => this.currentPanelId = res.id )
            }
        },

        savePanels() {
            const updatedItems = this.items
                .filter(item => item.dirty)
                .map(item => ({
                    id: item.id,
                    $update_origin: item.attributes,
                }))

            this.updateBatch({ data: updatedItems, options: { setNotification: true } })
        },

        deletePanel(item) {
            const attributes = _.get(item, 'attributes', item);
            const status = confirm('Are you sure to detach this panel from current page?');

            if (!status) {
                return;
            }

            this.updateBatch({
                data: [{ id: attributes.id, $detach: true }],
            });
        },

        changePriority(event) {
            event.preventDefault();

            const mainIndex = _.findIndex(this.items, (item) => item.id == 0);

            const beforeMain = _.slice(this.items, 0, mainIndex);
            const afterMain = _.slice(this.items, mainIndex + 1);

            const changedItemIds = _.concat(
                beforeMain.map(item => item.id),
                afterMain.map(item => item.id),
            );

            const updatedData = _.concat(
                _.sortBy(beforeMain, ['position']).map(item => ({ position: item.position, section: 'before' })),
                _.sortBy(afterMain, ['position']).map(item => ({ position: item.position, section: 'after' })),
            );

            const data = _.zip(changedItemIds, updatedData)
                .map(([id, $update]) => ({ id, $update }))

            this.updateBatchDelayed({
                data,
                options: {
                    setNotification: true,
                }
            });
            this.$emit('input');
        },

        getPanelDescription(type) {
            const helperMethod = this.helpers('getPanelDescription');
            if (helperMethod) {
                return helperMethod(type);
            }

            return 'Create a custom panel';
        },

        getPanelImage(type) {
            const helperMethod = this.helpers('getPanelImage');
            if (helperMethod) {
                return helperMethod(type);
            }

            return '/icons/Panel Type/General/Default@2x.png';
        },

        getPanelLabel(type) {
            const helperMethod = this.helpers('getPanelLabel');
            if (helperMethod) {
                return helperMethod(type);
            }

            return type;
        },

        getPanelPreviewLink() {
            return `/panel/${this.currentPanelId}?content_type=${this.page.type}&content_id=${this.page.id}`;
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/PageBuilderComponent.vue